import React from 'react';
import { MdStar, MdStarBorder } from 'react-icons/md';

const RATING_LABEL = ['', 'Poor', 'Fair', 'Good', 'Very good', 'Excellent'];

export function StarRow({ value, onChange, color = '#fbbf24' }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: 6 }}>
      {[1, 2, 3, 4, 5].map(i => (
        <button
          key={i}
          type="button"
          onClick={() => onChange(i)}
          style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 4 }}
        >
          {i <= value
            ? <MdStar size={34} style={{ color }} />
            : <MdStarBorder size={34} style={{ color: 'var(--text-muted)' }} />}
        </button>
      ))}
    </div>
  );
}

export default function ReviewRatingSection({
  icon, title, subtitle, value, onChange, accent, emptyHint,
}) {
  return (
    <div style={{
      padding: 14, borderRadius: 14, marginBottom: 12,
      background: 'var(--bg-card, rgba(255,255,255,0.04))',
      border: `1px solid ${accent}44`,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <span style={{ fontSize: 18 }}>{icon}</span>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 14 }}>{title}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {subtitle}
          </div>
        </div>
      </div>
      <StarRow value={value} onChange={onChange} color={accent} />
      <div style={{ textAlign: 'center', fontSize: 12, fontWeight: 700, color: accent, minHeight: 18, marginTop: 4 }}>
        {value ? RATING_LABEL[value] : emptyHint}
      </div>
    </div>
  );
}

export function ReviewDisplayCard({ review }) {
  const hospitalStars = Number(review.hospitalStars ?? review.stars ?? 0);
  const doctorStars = Number(review.doctorStars ?? 0);
  const doctorName = review.doctorName || '';
  const tags = Array.isArray(review.tags) ? review.tags : [];

  return (
    <div className="glass glass-p" style={{ marginBottom: 10 }}>
      <div style={{ fontWeight: 700, marginBottom: 8 }}>{review.displayName || 'Verified Patient'}</div>
      <RatingLine label="Hospital" icon="🏥" stars={hospitalStars} color="#3b82f6" />
      {doctorName && doctorStars > 0 && (
        <RatingLine label={`Dr. ${doctorName}`} icon="👨‍⚕️" stars={doctorStars} color="#10b981" />
      )}
      {doctorName && doctorStars <= 0 && (
        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>Visited Dr. {doctorName}</div>
      )}
      {review.comment && (
        <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 8, lineHeight: 1.45 }}>
          {review.comment}
        </div>
      )}
      {tags.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
          {tags.map(t => (
            <span key={t} className="badge" style={{ background: 'rgba(59,130,246,0.12)', color: '#3b82f6' }}>{t}</span>
          ))}
        </div>
      )}
    </div>
  );
}

function RatingLine({ label, icon, stars, color }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
      <span style={{ fontSize: 12 }}>{icon}</span>
      <span style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 600, flex: 1 }}>{label}</span>
      <span style={{ display: 'flex', gap: 1 }}>
        {[1, 2, 3, 4, 5].map(i => (
          i <= stars
            ? <MdStar key={i} size={14} style={{ color: '#fbbf24' }} />
            : <MdStarBorder key={i} size={14} style={{ color: 'var(--text-muted)' }} />
        ))}
      </span>
    </div>
  );
}
